import React from 'react'
import { IndexLink, Link } from 'react-router'
import { connect } from 'react-redux'
import { loginFormVisible, logout } from '../../store/login'

class FooterLayout extends React.Component {

    state = {
        isLogged: false
    };

    openLoginForm = (e) => {
        if (!this.state.isLogged) {
            e.preventDefault();
            this.loginForm(true);
        }
    };

    logout = () => {
        if (this.state.isLogged) {
            this.logout();
        }
    };

    constructor(props) {
        super(props);
        this.loginForm = this.props.loginWindow;
        this.logout = this.props.logout;
        this.state = {isLogged: this.props.isLogged};
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.isLogged !== this.state.isLogged) {
            this.setState({isLogged: nextProps.isLogged});
        }
    }

    render() {
        return (
            <div className="footer">
              <div className="container">
                <div className="row">
                    <div className="col-md-2 col-sm-6 f-menu">
                        <h3>MY ACCOUNT</h3>
                        <ul>
                          <li>
                            <IndexLink to='/account-info' className={'menu-link'}
                                       onClick={this.openLoginForm}
                                       activeClassName='page-layout__nav-item--active'>Account info</IndexLink>
                          </li>
                            <li>
                                <IndexLink to='/wallet' className="menu-link"
                                           onClick={this.openLoginForm}
                                           activeClassName='page-layout__nav-item--active'>Order history</IndexLink>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-2 col-sm-6 f-menu">
                        <h3>CUSTOMER SERVICE</h3>
                        <ul>
                            <li>
                                <IndexLink to='/cart' className="menu-link"
                                           onClick={this.openLoginForm}
                                           activeClassName='page-layout__nav-item--active'>My cart</IndexLink>
                            </li>
                            <li>
                                <IndexLink to='/faq' className="menu-link"
                                           activeClassName='page-layout__nav-item--active'>FAQ</IndexLink>
                            </li>
                          <li>
                            <IndexLink to='/contact-us' className="menu-link"
                                       activeClassName='page-layout__nav-item--active'>Contact us</IndexLink>
                          </li>
                          <li>
                            <IndexLink to='/help' className="menu-link"
                                       activeClassName='page-layout__nav-item--active'>Help</IndexLink>
                          </li>
                        </ul>
                    </div>
                    <div className="col-md-4 col-sm-12 logo-wrp">
                        <div className="logo-img">
                            <img className="site-logo" src="/images/logo-new.png" alt="xookers"/>                            
                        </div>
                        <div className="site-slogan">
                            <span className="">GREAT</span>
                            <span className="earn"><span />LOCAL<span/></span>
                            <span className="">DEALS</span>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12 social-networks-wrp">
                        <div className="row">
                            <div className="social-networks">
                                <a href="https://www.facebook.com/Xooker/" target="_blank">
                                    <img className="sn-icon" src="/images/icons/facebook.png" alt="xookers-facebook"/>
                                </a>
                                <a href="https://www.instagram.com/xooker/" target="_blank">
                                    <img className="sn-icon" src="/images/icons/instagram.png" alt="xookers-instagram"/>
                                </a>
                                <a href="https://www.youtube.com/channel/UC5ZyoVN3OjmCAcU_acq-pkQ" target="_blank">
                                    <img className="sn-icon" src="/images/icons/youtube.png" alt="xookers-youtube"/>
                                </a>
                                <a href="https://twitter.com/xooker" target="_blank">
                                    <img className="sn-icon" src="/images/icons/twitter.png" alt="xookers-twitter"/>
                                </a>
                                <a href="https://www.linkedin.com/company/xooker/" target="_blank">
                                    <img className="sn-icon" src="/images/icons/linkedin.png" alt="xookers-linkedin"/>
                                </a>
                            </div>
                        </div>
                        <div className="row">

                        <div className="app-downloads" style={{marginTop:"8px"}}>
                        <a href="https://itunes.apple.com/us/app/xooker/id983457467?mt=8" target="_blank"><img width="100" height="40" src="https://xooker.com/wp-content/uploads/2023/05/app-store.png" className="vc_single_image-img attachment-full" alt="Download on the App store"/></a>
                        <a href="https://play.google.com/store/apps/details?id=com.xooker.mobile.app" target="_blank"><img width="100" height="40" src="https://xooker.com/wp-content/uploads/2023/05/google-play.png" className="vc_single_image-img attachment-full" alt="Download on the Play store"/> </a>

                        </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                      <p className={'copy'}>
                     <IndexLink to='/contact-us' className="terms-link" activeClassName='page-layout__nav-item--active'>
                        Contact Us
                      </IndexLink>
                      <IndexLink to='/terms-conditions' className="terms-link" activeClassName='page-layout__nav-item--active'>
                        Terms and conditions
                      </IndexLink>
                      <a href='https://www.xooker.com/privacy-policy' target="_blank" className="terms-link" activeClassName='page-layout__nav-item--active'>
                        Privacy Policy
                      </a>
                      </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <p className={'copy'}>&copy;{(new Date().getFullYear())} Xooker, LLC. All Rights Reserved &nbsp;
                    </p>
                  </div>
                </div>
              </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        isLogged: state.token ? true : false
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        loginWindow: (value) => dispatch(loginFormVisible(value)),
        logout: (value) => dispatch(logout())
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FooterLayout);



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/FooterLayout.js